import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingle, useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import { useRef } from 'react';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { MpiOrderType, MpiPropertyAccess } from '~/tenants/mpi/model/MpiOrder';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';

export default function MpiOrderForm({ persona }: { persona: PersonaType }) {
  const [_type, type] = useZodFormFieldSingle<MpiOrderType>('type');
  const access = useZodFormFieldSingleValue<MpiPropertyAccess>('access');
  const preselected = useRef(type !== undefined);

  return (
    <FormGroup>
      {preselected.current && <ZodFieldHidden name="type" />}
      {!preselected.current && (
        <FormHorizontal name="type" label="Type">
          <ZodFieldSelect
            name="type"
            options={[
              {
                label: 'Residential',
                value: MpiOrderType.RESIDENTIAL,
              },
              ...(persona === PersonaType.OFFICE
                ? [
                    {
                      label: 'Commercial',
                      value: MpiOrderType.COMMERCIAL,
                    },
                  ]
                : []),
            ]}
          />
        </FormHorizontal>
      )}
      <FormHorizontal name="sqft" label="Square Feet">
        <ZodFieldInput name="sqft" type="number" />
      </FormHorizontal>
      <FormHorizontal name="access" label="Access Type">
        <ZodFieldSelect
          name="access"
          options={[
            {
              label: 'Will Provider Later',
              value: MpiPropertyAccess.LATER,
            },
            {
              label: 'Homeowner Will Meet Photographer',
              value: MpiPropertyAccess.HOMEOWNER,
            },
            {
              label: 'Lockbox Code',
              value: MpiPropertyAccess.LOCKBOX,
            },
            {
              label: 'Sentri Code',
              value: MpiPropertyAccess.SENTRI,
            },
            {
              label: 'Agent Will Meet Photographer',
              value: MpiPropertyAccess.AGENT,
            },
          ]}
        />
      </FormHorizontal>
      {access && [MpiPropertyAccess.LOCKBOX, MpiPropertyAccess.SENTRI].includes(access) && (
        <FormHorizontal name="code" label="Access Code">
          <ZodFieldInput name="code" type="text" />
        </FormHorizontal>
      )}
      <FormHorizontal name="coupon" label="Coupon Code">
        <ZodFieldInput name="coupon" />
      </FormHorizontal>
      <FormHorizontal name="notes" label="Notes & Special Instructions">
        <ZodFieldTextarea name="notes" />
      </FormHorizontal>
    </FormGroup>
  );
}
